import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { TermsConditionsContent } from "../UserTermsConditions";
import Footer from "../../../customComponents/Footer";

const UserAgreement = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Terms of Use – Arab Global Crypto Exchange (AGCEX)</title>
        <meta
          name="description"
          content="Terms of Use and Conditions of Arab Global Virtual Assets Services LLC SPC, trading as Arab Global Crypto Exchange. Read the binding terms that apply to your Trading Account."
        />
        <meta
          name="keywords"
          content="AGCEX terms of use, terms and conditions, Arab Global crypto exchange terms, MTF virtual assets UAE, CMA licensed exchange"
        />
      </Helmet>

      <TermsConditionsContent />
      <Footer />
    </>
  );
};

export default UserAgreement;
